import clsx from "clsx";
import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";
import classes from "./spinner.module.css";

export const SpinnerIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          viewBox="0 0 20 20"
          className={clsx(classes.root, className)}
          {...props}
          ref={ref}
        >
          <circle
            cx="10"
            cy="10"
            r="8"
            stroke="currentColor"
            strokeOpacity="0.35"
            strokeWidth="2"
          />
          <path
            d="M10 2C5.58172 2 2 5.58172 2 10C2 12.1304 2.83275 14.0663 4.1905 15.5"
            stroke="url(#paint0_linear_13309_22465)"
            strokeWidth="2"
          />
          <defs>
            <linearGradient
              id="paint0_linear_13309_22465"
              x1="2.75"
              y1="8.5"
              x2="0.707838"
              y2="13.6976"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="currentColor" />
              <stop offset="1" stopColor="currentColor" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </Icon>
    );
  },
);

SpinnerIcon.displayName = "SpinnerIcon";
